import type { Employee } from '@/api/models/company'
import type { Item } from '@/components'
import { TableHeadCell } from '@/modules/MedComplexList/components/MedComplexTable/components'
import { OrganizationContext } from '@/modules/Organization/Organization'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useContext, type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { styles } from './styles'
import type { EmployeesTableProps } from './types'

export const EmployeesTable: FC<EmployeesTableProps> = (props) => {
  const { data, cards } = props

  const { organizationId } = useContext(OrganizationContext)

  const navigate = useNavigate()

  return (
    <Box sx={styles.scrollBar}>
      <TableContainer sx={styles.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {cards.map((card) =>
                card.visible || !!card?.alwaysVisible ? (
                  <TableHeadCell item={card} key={card.id} />
                ) : null
              )}
            </TableRow>
          </TableHead>
          <TableBody sx={{ maxHeight: '600px' }}>
            {data?.map((item: Employee) => (
              <TableRow
                key={item.id}
                sx={styles.tableRow}
                onClick={() =>
                  navigate(
                    `/organization/${organizationId}/employee/${item.id}/general`,
                    {
                      replace: true,
                    }
                  )
                }
              >
                {cards.map((card: Item) =>
                  card.visible || !!card?.alwaysVisible ? (
                    <TableCell key={card.id}>{card.data(item)}</TableCell>
                  ) : null
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
